import { useAuthRedirect } from '@neo.tax/onboarding/hooks';
import { TestimonialMemo, StyledSplitScreen, AuthFormHeader } from '@neo.tax/onboarding/organisms';
import { Loader, useUrlQueryParam } from '@neo.tax/shared';

import { ResetPasswordForm } from './ResetPasswordForm';
import { ResetPasswordLinkForm } from './ResetPasswordLinkForm';

export const ResetPassword = (): React.ReactElement => {
  const oobCode = useUrlQueryParam('oobCode');

  return (
    <Loader useRedirect={useAuthRedirect}>
      <StyledSplitScreen
        leftSide={
          oobCode ? (
            <AuthFormHeader
              pageChangeText=""
              pageChangeLinkText=""
              pageChangeTo=""
              title="Reset Password"
              description="Please enter your new password below."
              form={<ResetPasswordForm oobCode={oobCode} />}
            />
          ) : (
            <AuthFormHeader
              pageChangeText="go back to"
              pageChangeLinkText="sign in"
              pageChangeTo="/login"
              title="Reset Password"
              description="Enter your email address, and we'll send you a link to reset your password."
              form={<ResetPasswordLinkForm />}
            />
          )
        }
        rightSide={<TestimonialMemo />}
      />
    </Loader>
  );
};
